import React from 'react';
import ReactDOM from 'react-dom';
import './themes/base.scss';
import App from './App';
import { configureStore } from './store';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import { ThemeProvider } from '@material-ui/core/styles';
import theme from './themes';
import { initializeApp } from 'firebase/app';
import firebaseConfig from './config/firebase';

initializeApp(firebaseConfig);

async function init() {
    const store = await configureStore();

    ReactDOM.render(
        <React.StrictMode>
            <Provider store={store}>
                <ThemeProvider theme={theme}>
                    <App />
                </ThemeProvider>
            </Provider>
        </React.StrictMode>,
        document.getElementById('root'),
    );

    serviceWorker.unregister();
}

init();
